import { render, staticRenderFns } from "./WattageDetail.vue?vue&type=template&id=4d2e7675&scoped=true"
import script from "./WattageDetail.vue?vue&type=script&lang=js"
export * from "./WattageDetail.vue?vue&type=script&lang=js"
import style0 from "./WattageDetail.vue?vue&type=style&index=0&id=4d2e7675&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2e7675",
  null
  
)

export default component.exports